import { render, staticRenderFns } from "./MyCoursesNavigation.vue?vue&type=template&id=cbc7ced2&"
import script from "./MyCoursesNavigation.vue?vue&type=script&lang=js&"
export * from "./MyCoursesNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesNavigation.vue?vue&type=style&index=0&id=cbc7ced2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports